export default {"src":"/_next/static/media/Arrow2.2e70d2f6.svg","height":218,"width":69,"blurWidth":0,"blurHeight":0};